/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./node_modules/@babel/runtime/regenerator/index.js":
/*!**********************************************************!*\
  !*** ./node_modules/@babel/runtime/regenerator/index.js ***!
  \**********************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

module.exports = __webpack_require__(/*! regenerator-runtime */ "./node_modules/regenerator-runtime/runtime.js");


/***/ }),

/***/ "./src/js/bundle/config.js":
/*!*********************************!*\
  !*** ./src/js/bundle/config.js ***!
  \*********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "parseTiers": () => (/* binding */ parseTiers),
/* harmony export */   "readBundleConfig": () => (/* binding */ readBundleConfig),
/* harmony export */   "usesComponentLines": () => (/* binding */ usesComponentLines)
/* harmony export */ });
/*
 * Reading a bundle's configuration off the host element's data- attributes.
 *
 * Liquid puts the Bundle Engine app metafield (product.metafields.app--378977320961.bundle_config) onto
 * the element as data-discount-type / -percentage / -tiers / -min-items / -max-items / -market-country.
 *
 * Only the pieces every surface reads the same way live here so far. The full reader lands with the
 * steps-engine merge: the rest of that parsing is entangled with each builder's own state, and the two
 * builders disagree on what "no maximum" is (0 in one, Infinity in the other), so unifying it is a
 * behaviour change that belongs with the QA pass for that merge rather than smuggled in here.
 */
// The config's `tiers` array, passed through as escaped JSON. A missing or malformed value degrades to
// "no tiers", which discountPercentageFor() reads as 0%, rather than throwing on first paint.
function parseTiers(raw) {
  if (!raw) return [];

  try {
    var tiers = JSON.parse(raw);
    return Array.isArray(tiers) ? tiers : [];
  } catch (error) {
    return [];
  }
}
/*
 * Returns:
 *   marketCountry      upper-cased ISO code, or '' when unknown. Upper case because the Storefront
 *                      CountryCode enum is, and @inContext rejects a lower-case value.
 *   minItems           0 when unset.
 *   maxItems           Infinity when unset or non-positive, NOT 0. Zero as a sentinel for "no maximum"
 *                      reads as "maximum of nothing" in any `count >= maxItems` test, which disables
 *                      every add CTA on first paint. Infinity is inert in that test and in the steps
 *                      builders' `maxItems > 0 && count > maxItems`, so both spellings behave alike.
 *   discountType       '' when unset.
 *   discountPercentage 0 when unset.
 *   discountTiers      [] when unset or malformed.
 *
 * The last three together are the { discountType, discountPercentage, discountTiers } shape that
 * discountPercentageFor() and applyDiscount() in ./pricing.js take, so the whole object passes straight
 * through.
 */

function readBundleConfig(el) {
  var data = el && el.dataset || {};
  var maxItems = parseInt(data.maxItems, 10);
  return {
    marketCountry: (data.marketCountry || '').toUpperCase(),
    minItems: parseInt(data.minItems, 10) || 0,
    maxItems: Number.isFinite(maxItems) && maxItems > 0 ? maxItems : Infinity,
    discountType: data.discountType || '',
    discountPercentage: parseFloat(data.discountPercentage) || 0,
    discountTiers: parseTiers(data.discountTiers)
  };
} // Which of the Bundle Engine's two cart shapes this bundle takes. Confirmed with the app 2026-09-04:
// it is dictated by discount_type, and getting it wrong means the bundle is not priced at all.
// percentage/tiered_percentage post one line per component with no parent line; fixed_price falls
// through to the theme's ordinary form post carrying _bundle_selections.

function usesComponentLines(config) {
  return config.discountType === 'percentage' || config.discountType === 'tiered_percentage';
}

/***/ }),

/***/ "./src/js/bundle/ids.js":
/*!******************************!*\
  !*** ./src/js/bundle/ids.js ***!
  \******************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "toNumericId": () => (/* binding */ toNumericId),
/* harmony export */   "toVariantGid": () => (/* binding */ toVariantGid),
/* harmony export */   "toProductGid": () => (/* binding */ toProductGid)
/* harmony export */ });
/*
 * Id coercion at the Shopify boundary.
 *
 * bundle_config (v3) stores bare numeric ids, never GIDs. The Storefront API only speaks GIDs. The DOM
 * carries whichever the Liquid that rendered it chose. So everything inside the module works in bare
 * numeric strings and widens only at the Storefront request.
 */
// Works on both "49110622208228" and "gid://shopify/ProductVariant/49110622208228". String()-coerced
// first, so it is safe on a number as well as a string.
var toNumericId = function toNumericId(id) {
  return String(id).split('/').pop();
};
var toVariantGid = function toVariantGid(numericId) {
  return "gid://shopify/ProductVariant/".concat(numericId);
};
var toProductGid = function toProductGid(numericId) {
  return "gid://shopify/Product/".concat(numericId);
};

/***/ }),

/***/ "./src/js/bundle/pricing.js":
/*!**********************************!*\
  !*** ./src/js/bundle/pricing.js ***!
  \**********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "toCents": () => (/* binding */ toCents),
/* harmony export */   "formatBundleMoney": () => (/* binding */ formatBundleMoney),
/* harmony export */   "maxSellablePrice": () => (/* binding */ maxSellablePrice),
/* harmony export */   "discountPercentageFor": () => (/* binding */ discountPercentageFor),
/* harmony export */   "applyDiscount": () => (/* binding */ applyDiscount),
/* harmony export */   "bundleDisplayPrice": () => (/* binding */ bundleDisplayPrice)
/* harmony export */ });
/* harmony import */ var _formatMoney_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../formatMoney.js */ "./src/js/formatMoney.js");
/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./config.js */ "./src/js/bundle/config.js");
/*
 * Every money figure a bundle surface displays. One implementation, because four disagreeing ones is
 * how a product card and its own PDP came to quote different savings for the same bundle.
 */

 // Storefront prices arrive as decimal strings ("24.00"). Cents are the unit throughout the module:
// bundle-analytics.js publishes cents, the discount maths rounds in cents, and converting in more than
// one place is how a rounding difference gets into a revenue figure.

function toCents(amount) {
  var value = parseFloat(amount);
  return Number.isFinite(value) ? Math.round(value * 100) : undefined;
} // Formats a price in the currency the Storefront request actually resolved (`currencyCode`) rather than
// the shop's static window.theme.moneyFormat, which is set once at page load from shop.money_format (see
// javascript-lang.liquid) and reflects only the shop's default market - so it can carry the wrong symbol
// for a shopper browsing in another one. Falls back to that static format when no currency has come back
// yet (nothing fetched, or the request failed) or the code is not one Intl recognises.
//
// `trimTrailingZeros` reproduces Liquid's money_without_trailing_zeros, for callers rendering alongside
// server-rendered prices that use it (product cards). Off by default.

function formatBundleMoney(cents, currencyCode) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref$trimTrailingZero = _ref.trimTrailingZeros,
      trimTrailingZeros = _ref$trimTrailingZero === void 0 ? false : _ref$trimTrailingZero;

  if (currencyCode) {
    try {
      var fractionDigits = trimTrailingZeros && cents % 100 === 0 ? 0 : 2;
      return new Intl.NumberFormat(document.documentElement.lang || undefined, {
        style: 'currency',
        currency: currencyCode,
        minimumFractionDigits: fractionDigits,
        maximumFractionDigits: fractionDigits
      }).format(cents / 100);
    } catch (error) {// Fall through to the static format below.
    }
  }

  return (0,_formatMoney_js__WEBPACK_IMPORTED_MODULE_0__.formatMoney)(cents, window.theme && window.theme.moneyFormat);
}
/*
 * The "bought separately" ceiling: the dearest price a set of variants could contribute to the
 * compare-at figure a saving is quoted against.
 *
 * SOLD-OUT VARIANTS ARE EXCLUDED. Agreed 2026-09-30, and it is a change for the steps builder, which
 * previously counted every variant regardless.
 *
 * Before this, the two implementations disagreed: maxVariantPrice() in product-bundle-2026.js counted
 * sold-out variants, getProductMaxPriceCents() in bundle-card-price.js did not, so a PDP and its own
 * product card quoted different savings for the same bundle. (The comment in the former asserting that
 * the card "likewise doesn't filter" had gone stale - the card was changed in the opposite direction on
 * SBA-982 and the comment was not updated.)
 *
 * Excluding is the defensible side of that: availableForSale is false both for a genuinely out-of-stock
 * variant and for one excluded from the buyer's market catalog, and in neither case can the shopper
 * actually buy it, so quoting a saving against it overstates the offer.
 *
 * Known consequence, which the old steps-builder comment recorded as an EU regression: where the dearest
 * variant is unavailable in a given market, the ceiling now falls to the dearest one that IS available,
 * so the displayed saving is smaller in that market than in one where the dearest is sellable. That is
 * the honest figure rather than a bug, but it does mean the same bundle can advertise different savings
 * market to market. Flagged for UAT.
 *
 * `entries` is [{ cents, available }] - each surface normalises its own variant shape into this.
 * Returns undefined when nothing resolved a price at all, so a caller can keep its server-rendered seed
 * rather than render a zero.
 */

function maxSellablePrice(entries) {
  var resolved = (entries || []).filter(function (entry) {
    return entry && Number.isFinite(entry.cents);
  });
  if (!resolved.length) return undefined;
  var sellable = resolved.filter(function (entry) {
    return entry.available !== false;
  }); // Nothing sellable is not the same as nothing priced. getProductMaxPriceCents() used to return 0 here,
  // which makes the compare-at price zero and the saving negative - worse than the overstatement this
  // rule exists to avoid. A fully sold-out step still has a real "bought separately" worth, so fall back
  // to the dearest resolved price. The step is unpurchasable anyway and the builder blocks the add.

  var pool = sellable.length ? sellable : resolved;
  return pool.reduce(function (max, entry) {
    return max === undefined || entry.cents > max ? entry.cents : max;
  }, undefined);
} // The percentage off `itemCount` selections earns under a bundle's config: a flat rate for "percentage",
// or the highest tier the count reaches for "tiered_percentage" (tiers are not guaranteed to arrive
// sorted, so this takes the best match rather than the last). Anything else, including a config with no
// discount set, is 0% rather than guessed at.
//
// `config` is { discountType, discountPercentage, discountTiers } - see readBundleConfig() in ./config.js.

function discountPercentageFor(config, itemCount) {
  if (!config) return 0;
  if (config.discountType === 'percentage') return config.discountPercentage || 0;

  if (config.discountType === 'tiered_percentage') {
    var tiers = config.discountTiers || [];
    return tiers.reduce(function (best, tier) {
      var minItems = parseInt(tier.min_items, 10);
      var percentage = parseFloat(tier.percentage);
      if (!Number.isFinite(minItems) || !Number.isFinite(percentage)) return best;
      if (itemCount < minItems) return best;
      return Math.max(best, percentage);
    }, 0);
  }

  return 0;
} // What `total` worth of components actually costs as a bundle, in cents. Display only - the real discount
// is applied at checkout by the Bundle Engine function, which this mirrors.

function applyDiscount(config, total, itemCount) {
  var percentage = discountPercentageFor(config, itemCount);
  if (!percentage) return total;
  return Math.round(total * (1 - percentage / 100));
}
/*
 * What a bundle actually costs the shopper, in cents - the figure that belongs in the price slot, with
 * `total` (the components bought separately) belonging in the struck-through one beside it.
 *
 * The two bundle shapes reach that figure from opposite ends, and conflating them is the bug this
 * exists to close:
 *   percentage / tiered_percentage - no parent cart line exists, so the price IS the discounted
 *                                    component sum and `fixedPrice` is meaningless (the bundle
 *                                    product's Admin price is 0 for these by convention anyway).
 *   fixed_price                    - ONE parent line, whose own Markets-resolved price is the whole
 *                                    bundle total; the components ride along inside it at no cost of
 *                                    their own. applyDiscount() returns `total` untouched here, because
 *                                    discountPercentageFor() knows no percentage for this type - so a
 *                                    surface that just displays its return value quotes the component
 *                                    sum as the price, shows no saving at all, and never mentions the
 *                                    price the shopper is actually charged.
 *
 * `fixedPrice` is the parent variant's price in cents, which Liquid stamps on the host element as
 * data-fixed-price (already Markets-resolved, so it is directly comparable with the @inContext
 * component prices `total` is built from). A missing or zero one falls back to the discounted total
 * rather than rendering a confident 0.00 - a bundle product with no price set is a merchandising
 * error, and the component sum is the least wrong thing to show while it stands.
 */

function bundleDisplayPrice(config, total, itemCount, fixedPrice) {
  var discounted = applyDiscount(config, total, itemCount);
  if ((0,_config_js__WEBPACK_IMPORTED_MODULE_1__.usesComponentLines)(config)) return discounted;
  return Number.isFinite(fixedPrice) && fixedPrice > 0 ? fixedPrice : discounted;
}

/***/ }),

/***/ "./src/js/bundle/storefront.js":
/*!*************************************!*\
  !*** ./src/js/bundle/storefront.js ***!
  \*************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "STOREFRONT_API_VERSION": () => (/* binding */ STOREFRONT_API_VERSION),
/* harmony export */   "BUNDLE_NODE_FIELDS": () => (/* binding */ BUNDLE_NODE_FIELDS),
/* harmony export */   "GRID_NODE_FIELDS": () => (/* binding */ GRID_NODE_FIELDS),
/* harmony export */   "VARIANT_PRICE_FIELDS": () => (/* binding */ VARIANT_PRICE_FIELDS),
/* harmony export */   "fetchBundleNodes": () => (/* binding */ fetchBundleNodes)
/* harmony export */ });
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/regenerator */ "./node_modules/@babel/runtime/regenerator/index.js");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);


function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

/*
 * The tokenless Storefront API client every bundle surface resolves its product data through.
 *
 * Moved from src/js/bundle-storefront.js (SBA-985), which itself came out of product-bundle-2026.js
 * (SBA-979). SBA-1041's src/js/bundle-shared.js was a second, earlier fork of the same code; it has been
 * deleted in favour of this, which is a strict superset of it.
 */
// Keep in sync with whatever Storefront API version the project targets elsewhere - confirmed 2026-08-21
// that this version needs no access token for Product/ProductVariant fields (tokenless access).
var STOREFRONT_API_VERSION = '2026-07'; // The field set the steps builder needs: enough to fill in a step row's image, title, price and OOS
// state. The grid builder asks for more (see GRID_NODE_FIELDS below) because its cards render a whole
// product tile plus an inline shade picker.

var BUNDLE_NODE_FIELDS = "\n  __typename\n  ... on Product {\n    id\n    title\n    handle\n    featuredImage {\n      url\n      altText\n    }\n  }\n  ... on ProductVariant {\n    id\n    title\n    price {\n      amount\n      currencyCode\n    }\n    availableForSale\n  }\n"; // SBA-985. The grid builder resolves a whole card from one request rather than the steps builder's
// image/title/price, so it also takes:
//   availableForSale  - whether ANY variant is in stock, which is what sinks a card to the base of its
//                       group in the suppressed/waitlist state.
//   priceRange        - the "from" price shown on a card before a shade is picked. compareAtPriceRange
//                       drives the struck-through price on the card.
//   tags              - the card's "MADE IN KOREA"/"NEW" badge, which product-card-2026 derives from a
//                       product's `card-tag-*` tags.
//   variants(100)     - so a card's shade picker can be built and priced without a second request.
//                       100 is the API's per-page ceiling and comfortably above the largest real shade
//                       range on this shop (42 across the whole test bundle).
// Deliberately NOT asked for: metafields. Storefront access isn't granted on this shop's metafield
// definitions (that's why the steps builder fetches short descriptions from [handle].js separately),
// and an inaccessible field would surface as a GraphQL error on every request.

var GRID_NODE_FIELDS = "\n  __typename\n  ... on Product {\n    id\n    title\n    handle\n    tags\n    availableForSale\n    featuredImage {\n      url\n      altText\n    }\n    priceRange {\n      minVariantPrice { amount currencyCode }\n    }\n    compareAtPriceRange {\n      minVariantPrice { amount currencyCode }\n    }\n    variants(first: 100) {\n      nodes {\n        id\n        title\n        availableForSale\n        price { amount currencyCode }\n        image { url altText }\n      }\n    }\n  }\n  ... on ProductVariant {\n    id\n    title\n    price {\n      amount\n      currencyCode\n    }\n    availableForSale\n  }\n"; // The leanest set: just enough to price a variant and know whether it can be bought. Used by the product
// card, which resolves only prices and never renders a product's own title or image from the response.

var VARIANT_PRICE_FIELDS = "\n  ... on ProductVariant {\n    id\n    availableForSale\n    price {\n      amount\n      currencyCode\n    }\n  }\n";

var nodesQuery = function nodesQuery(fields) {
  return "\n  query BundleProducts($ids: [ID!]!) {\n    nodes(ids: $ids) {\n      ".concat(fields, "\n    }\n  }\n");
}; // Used whenever the buyer's active Markets country is known (data-market-country on the builder element,
// sourced from Liquid's localization.country.iso_code). Without @inContext, the tokenless request always
// resolves price.amount in the shop's default market/currency regardless of which one the buyer is
// actually browsing in - which is how a shopper in a EUR market could see a EUR amount rendered with the
// shop's default GBP symbol (formatBundleMoney() below covers the symbol side; this covers the amount).


var nodesQueryInContext = function nodesQueryInContext(fields) {
  return "\n  query BundleProducts($ids: [ID!]!, $country: CountryCode!) @inContext(country: $country) {\n    nodes(ids: $ids) {\n      ".concat(fields, "\n    }\n  }\n");
}; // One tokenless Storefront request for a batch of Product/ProductVariant GIDs.
//
// `country` is the buyer's active Markets country (may be blank, in which case the request falls back to
// the shop's default market). `fields` is the inline fragment set to select - BUNDLE_NODE_FIELDS or
// GRID_NODE_FIELDS above.


function fetchBundleNodes(_x) {
  return _fetchBundleNodes.apply(this, arguments);
}

function _fetchBundleNodes() {
  _fetchBundleNodes = _asyncToGenerator( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(ids) {
    var _ref,
        country,
        _ref$fields,
        fields,
        useContext,
        response,
        _yield$response$json,
        data,
        errors,
        _args = arguments;

    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _ref = _args.length > 1 && _args[1] !== undefined ? _args[1] : {}, country = _ref.country, _ref$fields = _ref.fields, fields = _ref$fields === void 0 ? BUNDLE_NODE_FIELDS : _ref$fields;
            useContext = Boolean(country);
            _context.next = 4;
            return fetch("/api/".concat(STOREFRONT_API_VERSION, "/graphql.json"), {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                query: useContext ? nodesQueryInContext(fields) : nodesQuery(fields),
                variables: useContext ? {
                  ids: ids,
                  country: country
                } : {
                  ids: ids
                }
              })
            });

          case 4:
            response = _context.sent;

            if (response.ok) {
              _context.next = 7;
              break;
            }

            throw new Error("Storefront API request failed: ".concat(response.status));

          case 7:
            _context.next = 9;
            return response.json();

          case 9:
            _yield$response$json = _context.sent;
            data = _yield$response$json.data;
            errors = _yield$response$json.errors;

            // A single inaccessible field (e.g. a metafield without Storefront API access granted on its
            // definition) surfaces as a GraphQL error alongside otherwise-usable `data` - only throw (and so abort
            // every card's image/price) when there's no data to fall back on. Log the rest so a real access/config
            // problem is still visible in the console rather than silently swallowed.
            if (errors && errors.length) {
              console.error('Bundle: Storefront API returned errors', errors);
            }

            if (!(!data && errors && errors.length)) {
              _context.next = 15;
              break;
            }

            throw new Error(errors[0].message);

          case 15:
            return _context.abrupt("return", data && data.nodes || []);

          case 16:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _fetchBundleNodes.apply(this, arguments);
}

/***/ }),

/***/ "./src/js/formatMoney.js":
/*!*******************************!*\
  !*** ./src/js/formatMoney.js ***!
  \*******************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "formatMoney": () => (/* binding */ formatMoney)
/* harmony export */ });
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
function formatMoney(cents, format) {
  if (typeof cents == 'string') {
    cents = cents.replace('.', '');
  }

  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || "${{amount}}";

  function defaultOption(opt, def) {
    return typeof opt == 'undefined' ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);
    var parts = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents = parts[1] ? decimal + parts[1] : '';
    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;

    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;

    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;

    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;

    case "amount_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 2, "'", ".");
      break;
  }

  return formatString.replace(placeholderRegex, value);
}
;

/***/ }),

/***/ "./node_modules/regenerator-runtime/runtime.js":
/*!*****************************************************!*\
  !*** ./node_modules/regenerator-runtime/runtime.js ***!
  \*****************************************************/
/***/ ((module) => {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var runtime = (function (exports) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
    return obj[key];
  }
  try {
    // IE 8 has a broken Object.defineProperty that only works on DOM objects.
    define({}, "");
  } catch (err) {
    define = function(obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  exports.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = GeneratorFunctionPrototype;
  define(Gp, "constructor", GeneratorFunctionPrototype);
  define(GeneratorFunctionPrototype, "constructor", GeneratorFunction);
  GeneratorFunction.displayName = define(
    GeneratorFunctionPrototype,
    toStringTagSymbol,
    "GeneratorFunction"
  );

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      define(prototype, method, function(arg) {
        return this._invoke(method, arg);
      });
    });
  }

  exports.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  exports.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      define(genFun, toStringTagSymbol, "GeneratorFunction");
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  exports.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return PromiseImpl.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return PromiseImpl.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function(error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  });
  exports.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    if (PromiseImpl === void 0) PromiseImpl = Promise;

    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList),
      PromiseImpl
    );

    return exports.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        // Note: ["return"] must be used for ES3 parsing compatibility.
        if (delegate.iterator["return"]) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  define(Gp, toStringTagSymbol, "Generator");

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  define(Gp, iteratorSymbol, function() {
    return this;
  });

  define(Gp, "toString", function() {
    return "[object Generator]";
  });

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  exports.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  exports.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };

  // Regardless of whether this script is executing as a CommonJS module
  // or not, return the runtime object so that we can declare the variable
  // regeneratorRuntime in the outer scope, which allows this module to be
  // injected easily by `bin/regenerator --include-runtime script.js`.
  return exports;

}(
  // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
   true ? module.exports : 0
));

try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  // This module should not be running in strict mode, so the above
  // assignment should always work unless something is misconfigured. Just
  // in case runtime.js accidentally runs in strict mode, in modern engines
  // we can explicitly access globalThis. In older engines we can escape
  // strict mode using a global Function call. This could conceivably fail
  // if a Content Security Policy forbids using Function, but in that case
  // the proper solution is to fix the accidental strict mode problem. If
  // you've misconfigured your bundler to force strict mode and applied a
  // CSP to forbid Function, and you're not willing to fix either of those
  // problems, please detail your unique predicament in a GitHub issue.
  if (typeof globalThis === "object") {
    globalThis.regeneratorRuntime = runtime;
  } else {
    Function("r", "regeneratorRuntime = r")(runtime);
  }
}


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be in strict mode.
(() => {
"use strict";
/*!*************************************!*\
  !*** ./src/js/bundle-card-price.js ***!
  \*************************************/
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _bundle_ids_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./bundle/ids.js */ "./src/js/bundle/ids.js");
/* harmony import */ var _bundle_storefront_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./bundle/storefront.js */ "./src/js/bundle/storefront.js");
/* harmony import */ var _bundle_pricing_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./bundle/pricing.js */ "./src/js/bundle/pricing.js");
/**
 * bundle-card-price.js
 *
 * Calculates the maximum possible bundle price by fetching live variant prices
 * from the Storefront GraphQL API - one request per card, covering every variant
 * across every step of that bundle.
 *
 * The bundle_config metafield (schema v3) stores each component as a numeric
 * product_id/variant_ids pair, never a handle, so prices are resolved the same
 * way the PDP bundle builder resolves them (see fetchBundleNodes() and
 * toVariantGid() in product-bundle-2026.js): build ProductVariant GIDs from the
 * numeric ids and look them up via nodes(ids: ...).
 *
 * Resolved via @inContext(country: ...) using the buyer's active Markets country
 * (window.theme.marketCountry, sourced from Liquid's localization.country.iso_code
 * - see javascript-lang.liquid) so the amount comes back already converted into the
 * buyer's presentment currency, rather than the shop's default market/currency.
 *
 * Updates per card:
 *   [data-bundle-hero-price]            – what the bundle costs: the discounted
 *                                         component total, or the bundle product's
 *                                         own price for a fixed_price bundle
 *   [data-bundle-hero-compare-at-price] – undiscounted component total
 *   [data-bundle-hero-saving]           – saving badge wrapper
 *   [data-bundle-hero-saving-amount]    – saving amount span
 *
 * Falls back to a component's bundle_config snapshot price if none of its
 * variants resolve (missing/deleted variant, or the request fails outright).
 */
// Imported from the specific module files rather than ./bundle/index.js. This script loads on every
// collection page with a bundle card on it, and the barrel would pull the whole module - cart submission,
// analytics, drawers - into a bundle that needs none of it.



var marketCountry = (window.theme && window.theme.marketCountry || '').toUpperCase(); // ── helpers ──────────────────────────────────────────────────────────────────
// Set once the first priced response comes back - every request in the same page load resolves in the
// same currency, so one value covers every bundle card on the page. Read instead of assuming the shop's
// static default window.theme.moneyFormat matches the amount that was fetched.

var currencyCode = '';

function formatCardMoney(cents) {
  return (0,_bundle_pricing_js__WEBPACK_IMPORTED_MODULE_2__.formatBundleMoney)(cents, currencyCode, {
    trimTrailingZeros: true
  });
} // ── Storefront variant price cache (shared across all cards on the page) ─────
// numeric variant id → { cents, available }. Availability is carried alongside the price because
// maxSellablePrice() excludes sold-out variants from the "bought separately" ceiling - the shopper can't
// buy them, so including them overstates both the compare-at total and the saving claimed off it.


var _variantPriceCache = {};

function fetchVariantPrices(variantIds) {
  var missing = variantIds.filter(function (id) {
    return _variantPriceCache[id] === undefined;
  });
  if (!missing.length) return Promise.resolve();
  return (0,_bundle_storefront_js__WEBPACK_IMPORTED_MODULE_1__.fetchBundleNodes)(missing.map(_bundle_ids_js__WEBPACK_IMPORTED_MODULE_0__.toVariantGid), {
    country: marketCountry,
    fields: _bundle_storefront_js__WEBPACK_IMPORTED_MODULE_1__.VARIANT_PRICE_FIELDS
  }).then(function (nodes) {
    nodes.forEach(function (node) {
      if (!node || !node.price) return;
      if (!currencyCode) currencyCode = node.price.currencyCode;
      _variantPriceCache[(0,_bundle_ids_js__WEBPACK_IMPORTED_MODULE_0__.toNumericId)(node.id)] = {
        cents: (0,_bundle_pricing_js__WEBPACK_IMPORTED_MODULE_2__.toCents)(node.price.amount),
        available: node.availableForSale !== false
      };
    });
  });
} // The dearest buyable variant of a product, in cents. The bundle_config snapshot is used only when
// NOTHING resolved (a deleted variant, or the request failed outright), i.e. when availability is unknown
// rather than known. maxSellablePrice() owns the sold-out rule - see ./bundle/pricing.js.


function getProductMaxPriceCents(product) {
  var resolved = (product.variant_ids || []).map(function (id) {
    return _variantPriceCache[id];
  }).filter(function (entry) {
    return entry !== undefined;
  });
  if (!resolved.length) return (0,_bundle_pricing_js__WEBPACK_IMPORTED_MODULE_2__.toCents)(product.price || '0') || 0;
  return (0,_bundle_pricing_js__WEBPACK_IMPORTED_MODULE_2__.maxSellablePrice)(resolved) || 0;
}

function getStepMaxPriceCents(step) {
  var products = step.products || [];
  if (!products.length) return 0;
  return Math.max.apply(null, products.map(getProductMaxPriceCents).concat([0]));
} // bundle_config's own key names, mapped onto the { discountType, discountPercentage, discountTiers } shape
// ./bundle/pricing.js takes. This script reads the raw metafield JSON embedded per card, not the
// data-discount-* attributes the builders read, so readBundleConfig() does not apply.


function cardDiscountConfig(config) {
  return {
    discountType: config.discount_type || '',
    discountPercentage: parseFloat(config.percentage) || 0,
    discountTiers: Array.isArray(config.tiers) ? config.tiers : []
  };
}

function calcBundleMaxPrices(config, fixedPriceCents) {
  var steps = (config.groups || []).filter(function (g) {
    return g.role === 'step';
  });
  var discountConfig = cardDiscountConfig(config);
  var allVariantIds = [];
  steps.forEach(function (step) {
    (step.products || []).forEach(function (product) {
      (product.variant_ids || []).forEach(function (id) {
        allVariantIds.push(id);
      });
    });
  });
  return fetchVariantPrices(allVariantIds)["catch"](function (e) {
    console.warn('[bundle-card-price] variant price fetch failed, falling back to snapshot prices', e);
  }).then(function () {
    var compareAtCents = steps.reduce(function (sum, step) {
      return sum + getStepMaxPriceCents(step);
    }, 0); // One product per step at most, so the step count is the item count a tiered rate keys off.
    // Previously this read config.percentage alone, which is absent on a tiered_percentage bundle, so
    // every tiered bundle rendered its card with no discount and no saving badge at all.
    //
    // bundleDisplayPrice() rather than applyDiscount() so a fixed_price bundle shows the parent
    // product's own price - the card used to overwrite that server-rendered price with the component
    // ceiling, which is the one figure on the card that is certainly NOT what the bundle costs.

    var priceCents = (0,_bundle_pricing_js__WEBPACK_IMPORTED_MODULE_2__.bundleDisplayPrice)(discountConfig, compareAtCents, steps.length, fixedPriceCents);
    var savingCents = compareAtCents - priceCents;
    return {
      priceCents: priceCents,
      compareAtCents: compareAtCents,
      savingCents: savingCents
    };
  });
} // ── per-card update ───────────────────────────────────────────────────────────


function updateBundleCard(card) {
  var configScript = card.querySelector('script[type="application/json"][data-bundle-config]');
  if (!configScript) return;
  var config;

  try {
    config = JSON.parse(configScript.textContent);
  } catch (e) {
    return;
  } // The bundle product's own Markets-resolved price, stamped on the config script by Liquid. Only
  // fixed_price reads it (it is 0 for the other types by convention); parsed here rather than inside
  // the maths so a card with no attribute at all - any snippet not yet carrying it - degrades to the
  // previous behaviour instead of pricing the bundle at zero.


  var fixedPriceCents = parseInt(configScript.dataset.bundleFixedPrice || '0', 10);
  calcBundleMaxPrices(config, fixedPriceCents).then(function (prices) {
    if (prices.compareAtCents === 0) return;
    var hasDiscount = prices.savingCents > 0;
    var priceEl = card.querySelector('[data-bundle-hero-price]');
    var compareEl = card.querySelector('[data-bundle-hero-compare-at-price]');
    var savingEl = card.querySelector('[data-bundle-hero-saving]');
    var savingAmountEl = card.querySelector('[data-bundle-hero-saving-amount]');
    if (priceEl) priceEl.textContent = formatCardMoney(prices.priceCents); // Toggles both the native `hidden` attribute (how a product card's own compare-at/saving markup
    // starts hidden - see product-card-2026.liquid) and the Tailwind "hidden" utility class (how
    // product-prices-labels.liquid starts them hidden instead, server-rendered from the bundle's own
    // - always 0 for a percentage/tiered_percentage bundle - Admin price). Setting only the property
    // left the class in place, so the compare-at price and saving badge stayed invisible on the
    // "Complete Your Routine" widget (bundle-modal-trigger.liquid) even once priced correctly.
    // Matches heroCompareAtPriceEl/heroSavingEl in updateHeroSaving() (product-bundle-2026.js), which
    // already only ever used classList.toggle() for the same reason.

    if (compareEl) {
      compareEl.textContent = hasDiscount ? formatCardMoney(prices.compareAtCents) : '';
      compareEl.hidden = !hasDiscount;
      compareEl.classList.toggle('hidden', !hasDiscount);
    }

    if (savingEl) {
      savingEl.hidden = !hasDiscount;
      savingEl.classList.toggle('hidden', !hasDiscount);

      if (hasDiscount && savingAmountEl) {
        savingAmountEl.textContent = formatCardMoney(prices.savingCents);
      }
    }
  })["catch"](function (e) {
    console.warn('[bundle-card-price] failed to update card', e);
  });
} // ── init ──────────────────────────────────────────────────────────────────────


function init() {
  // .product-card covers every bundle product card; [data-bundle-price-widget] additionally covers the
  // "Complete Your Routine" bundle row on another product's PDP (see bundle-modal-trigger.liquid),
  // which needs the exact same live total but isn't itself a product card.
  document.querySelectorAll('.product-card, [data-bundle-price-widget]').forEach(updateBundleCard);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
})();

/******/ })()
;